import styled from 'styled-components';
import Wra16A from 'dc/Wra16A';
import APH120 from 'dc/APH120';
import { Typ20 } from 'dc/Typ';

import { ShortWrapper } from '../../elements';

export const Wrapper = styled(ShortWrapper)`
  background: #ffffff;
  border-radius: 4px;
`;

export const ProfileWrapper = styled(Wra16A)`
  width: 100%;
`;

export const Header = styled(APH120)``;

export const Content = styled(Typ20)`
  padding: 0 16px 16px 68px;
  display: block;
`;
